import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import CoinDetail from "@/pages/CoinDetail";

function App() {
  return (
    <div className="min-h-screen bg-[#07090e] text-slate-50">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/coin/:id" element={<CoinDetail />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
